//总后台接口管理
export default {
	getlist: '/base/info/getlist',	
	getinfo: '/base/info/getinfo',
	getcaptcha:'/base/captcha/getcaptcha',
	addinform:'/base/inform/addinform',
	companyRecommend: '/base/company/getrecommend',
	workerRecommend: '/base/worker/getrecommend',
	baseImgUrl: '/base/webset/getinfobysetid'
}
